import axios from 'axios';
import querystring from 'querystring';
import {
  instance,
} from './index';

const login = async (user) => {
  const cpApiInstance = axios.create({
    baseURL: 'https://cpapi.sambapos.com',
  });

  const qsData = querystring.stringify(user);
  let errorCode = '4010';
  let errorMessage = '';
  const cpApiRes = await cpApiInstance.post('/auth/login/', qsData)
    .then((result) => result)
    .catch((error) => {
      if (error.response) {
        console.log('error.response', error.response);
        if (error.response.data.errors.length > 0) {
          console.log('error.response.data.errors', error.response.data.errors);
          if (error.response.data.errors[0].message.trim() === 'Authentication failed.'
            || error.response.data.errors[0].message.trim() === 'Authentication failed'
            || error.response.data.errors[0].message.trim() === 'Giriş Başarısız'
            || error.response.data.errors[0].message.trim() === 'Giriş Başarısız.'
            || error.response.data.errors[0].message.trim() === 'Giris Basarisiz'
            || error.response.data.errors[0].message.trim() === 'Giris Basarisiz.'
            || error.response.data.errors[0].message.trim() === 'Giriş başarısız'
            || error.response.data.errors[0].message.trim() === 'Giriş başarısız.'
            || error.response.data.errors[0].message.trim() === 'Giris basarisiz'
            || error.response.data.errors[0].message.trim() === 'Giris basarisiz.') {
            errorCode = '4011';
            errorMessage = 'USERNOTFOUND';
          } else {
            errorMessage = cpApiRes.response.data.errors[0].message;
          }
        }
      }
      return error;
    });

  if (cpApiRes.message && cpApiRes.message === 'Network Error') {
    return { data: { errorMessage: cpApiRes.message, errorCode: '500' } };
  }

  if (errorCode === '4011') {
    return { data: { errorMessage, errorCode: '401' } };
  }

  if (cpApiRes.data && cpApiRes.data.token) {
    const res = await instance.post('/auth', user).then((result) => result, (error) => {
      console.log('error', JSON.parse(JSON.stringify(error)));
      if (error.response) {
        console.log('error.response', error.response);
        return error.response;
      } if (error.message) {
        console.log('error.message', error.message);
        return { data: { errorMessage: error.message, errorCode: '404' } };
      }
      console.log('error', error);
      return error;
    });

    return { ...res };
  }
  return { data: { errorMessage: 'License not found', errorCode } };
};

const logout = () => {
  localStorage.removeItem('user');
};

export {
  login,
  logout,
};
